import React, { useRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Menu, MenuItem, Button, Divider } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { startCase } from "lodash";
import { SearchType } from "./ChatStats";
import PublicResourceCentreSelector from "./PublicResourceCentreSelector";
import UserSelect from "./UserSelect";

interface Props {
  onSearch: (value: SearchType) => void;
}

enum FILTERS {
  USER = "USER",
  RESOURCECENTRE = "RESOURCECENTRE"
}

const ChatSearch = ({ onSearch }: Props): JSX.Element => {
  const toggleRef = useRef(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [activeFilter, setActiveFilter] = React.useState(FILTERS.USER);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: "5px",
        height: "35px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        transition: "width .5s, background 1s ease",
        backgroundColor: "#ececec",
        width: "300px"
      }}
    >
      <SearchIcon sx={{ position: "absolute", width: "35px" }} />
      <Box width="350px">
        {activeFilter === FILTERS.USER ? (
          <UserSelect onSearch={onSearch} />
        ) : (
          <PublicResourceCentreSelector onSearch={onSearch} />
        )}
      </Box>
      <Divider sx={{ height: 20, marginRight: 5 }} orientation="vertical" />
      <div>
        <Button aria-haspopup="true" onClick={handleClick} sx={{ paddingLeft: 0 }}>
          {startCase(activeFilter)} <ExpandMoreIcon />
        </Button>
        <Menu
          ref={toggleRef}
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          {Object.keys(FILTERS).map((item) => (
            <MenuItem
              key={item}
              onClick={() => {
                setAnchorEl(null);
                setActiveFilter(item as FILTERS);
              }}
            >
              {startCase(item)}
            </MenuItem>
          ))}
        </Menu>
      </div>
    </Box>
  );
};

export default ChatSearch;
